module.exports = __webpack_public_path__ + "assets/img/cart_ok.10d3d270.png";